export default "__VITE_ASSET__BatBuNPq__"